import {MouseEvent} from "react";
import classNames from "classnames";

import {Placeholder} from "@pg-design/image-module";
import {SliderGallery, SliderGallerySlideNavigation} from "@pg-design/slider-gallery-module";

import {PROPERTY_GALLERY_CONTENT} from "../../constants/property_gallery_content";
import {useInlineGalleryChrome} from "../../hooks/use_inline_gallery_chrome";
import {usePropertyGalleryImages} from "../../hooks/use_property_gallery_images";
import {IPropertyDetailDTO} from "../../types/property/IPropertyDetailDTO";
import {getGalleryImageDisplayUrl} from "../../utils/get_property_gallery_images";
import {renderInlineGalleryArrow} from "../gallery/InlineGalleryArrow";
import {InlineGalleryOverlays} from "../gallery/InlineGalleryOverlays";

import * as styles from "./HomematchPropertyCardDetailGallery.module.css";

interface IProps {
    property: IPropertyDetailDTO;
    arrowFill?: string;
    onSlideChange?: (currentSlideIndex: number, nextSlideIndex: number, navigation?: SliderGallerySlideNavigation) => void;
    onSlideClick?: () => void;
}

const CARD_DETAIL_GALLERY_HEIGHT = 474;
const CARD_DETAIL_GALLERY_WIDTH = 639;

export const HomematchPropertyCardDetailGallery = (props: IProps) => {
    const {arrowFill, onSlideChange, onSlideClick, property} = props;

    const {images: galleryImages} = usePropertyGalleryImages(property);
    const hasGalleryImages = galleryImages.length > 0;

    const {activeIndex, handleSlideChange, shouldShowDots, shouldShowOnboarding} = useInlineGalleryChrome({
        slidesCount: galleryImages.length,
        onSlideChange
    });

    const handleSlideClick = onSlideClick
        ? (event: MouseEvent) => {
              event.preventDefault();
              event.stopPropagation();
              onSlideClick();
          }
        : undefined;

    if (!hasGalleryImages) return <Placeholder />;

    return (
        <div className={styles.galleryHolder}>
            <div className={styles.galleryFrame}>
                <SliderGallery
                    arrows={{
                        left: renderInlineGalleryArrow("left", arrowFill),
                        right: renderInlineGalleryArrow("right", arrowFill)
                    }}
                    className={classNames("gallery", styles.sliderGallery)}
                    onSlideChange={handleSlideChange}
                    slides={galleryImages.map((image, index) => {
                        const imageSrc = getGalleryImageDisplayUrl(image);

                        return (
                            <picture
                                className={classNames(styles.slide, handleSlideClick && styles.slideClickable, image.isPlan && styles.planSlide)}
                                key={index}
                                onClick={handleSlideClick}
                            >
                                {imageSrc && (
                                    <img
                                        alt={PROPERTY_GALLERY_CONTENT.getSlideImageAlt(index)}
                                        height={String(CARD_DETAIL_GALLERY_HEIGHT)}
                                        src={imageSrc}
                                        width={String(CARD_DETAIL_GALLERY_WIDTH)}
                                    />
                                )}
                            </picture>
                        );
                    })}
                />
                <InlineGalleryOverlays
                    activeIndex={activeIndex}
                    dotsClassName={styles.cardDetailDotsOffset}
                    shouldShowDots={shouldShowDots}
                    shouldShowOnboarding={shouldShowOnboarding}
                    slidesCount={galleryImages.length}
                />
            </div>
        </div>
    );
};
import {MouseEvent} from "react";
import classNames from "classnames";

import {Placeholder} from "@pg-design/image-module";
import {SliderGallery, SliderGallerySlideNavigation} from "@pg-design/slider-gallery-module";

import {PROPERTY_GALLERY_CONTENT} from "../../constants/property_gallery_content";
import {useInlineGalleryChrome} from "../../hooks/use_inline_gallery_chrome";
import {usePropertyGalleryImages} from "../../hooks/use_property_gallery_images";
import {IPropertyDetailDTO} from "../../types/property/IPropertyDetailDTO";
import {getGalleryImageDisplayUrl} from "../../utils/get_property_gallery_images";
import {renderInlineGalleryArrow} from "../gallery/InlineGalleryArrow";
import {InlineGalleryOverlays} from "../gallery/InlineGalleryOverlays";

import * as styles from "./HomematchPropertyCardDetailGallery.module.css";

interface IProps {
    property: IPropertyDetailDTO;
    arrowFill?: string;
    onSlideChange?: (currentSlideIndex: number, nextSlideIndex: number, navigation?: SliderGallerySlideNavigation) => void;
    onSlideClick?: () => void;
}

const CARD_DETAIL_GALLERY_HEIGHT = 474;
const CARD_DETAIL_GALLERY_WIDTH = 639;

export const HomematchPropertyCardDetailGallery = (props: IProps) => {
    const {arrowFill, onSlideChange, onSlideClick, property} = props;

    const {images: galleryImages} = usePropertyGalleryImages(property);
    const hasGalleryImages = galleryImages.length > 0;

    const {activeIndex, handleSlideChange, shouldShowDots, shouldShowOnboarding} = useInlineGalleryChrome({
        slidesCount: galleryImages.length,
        onSlideChange
    });

    const handleSlideClick = onSlideClick
        ? (event: MouseEvent) => {
              event.preventDefault();
              event.stopPropagation();
              onSlideClick();
          }
        : undefined;

    if (!hasGalleryImages) return <Placeholder />;

    return (
        <div className={styles.galleryHolder}>
            <div className={styles.galleryFrame}>
                <SliderGallery
                    arrows={{
                        left: renderInlineGalleryArrow("left", arrowFill),
                        right: renderInlineGalleryArrow("right", arrowFill)
                    }}
                    className={classNames("gallery", styles.sliderGallery)}
                    onSlideChange={handleSlideChange}
                    slides={galleryImages.map((image, index) => {
                        const imageSrc = getGalleryImageDisplayUrl(image);

                        return (
                            <picture
                                className={classNames(styles.slide, handleSlideClick && styles.slideClickable, image.isPlan && styles.planSlide)}
                                key={index}
                                onClick={handleSlideClick}
                            >
                                {imageSrc && (
                                    <img
                                        alt={PROPERTY_GALLERY_CONTENT.getSlideImageAlt(index)}
                                        height={String(CARD_DETAIL_GALLERY_HEIGHT)}
                                        src={imageSrc}
                                        width={String(CARD_DETAIL_GALLERY_WIDTH)}
                                    />
                                )}
                            </picture>
                        );
                    })}
                />
                <InlineGalleryOverlays
                    activeIndex={activeIndex}
                    dotsClassName={styles.cardDetailDotsOffset}
                    shouldShowDots={shouldShowDots}
                    shouldShowOnboarding={shouldShowOnboarding}
                    slidesCount={galleryImages.length}
                />
            </div>
        </div>
    );
};
